import React, { useState, useEffect } from "react";
import { observer } from "mobx-react";
import Cast from "./components/Cast";
import Crowd from "./components/Crowd";
import FinalCta from "./components/FinalCta";
import FounderNote from "./components/FounderNote";
import GoldenCircle from "./components/GoldenCircle";
import Hero from "./components/Hero";
import Humans from "./components/Humans";
import Manifesto from "./components/Manifesto";
import Numbers from "./components/Numbers";
import SkillsSection from "./components/SkillsSection";
import Stories from "./components/Stories";
import Icons from "./components/Icons";
import { getRequest } from "../../../utils/httpRequest";

const CACHE_KEY = "landing_courses_cache";
const CACHE_DURATION = 24 * 60 * 60 * 1000; // 24 hours

const About = () => {
  const [enrolmentCount, setEnrolmentCount] = useState(0);
  const [courseCount, setCourseCount] = useState(0);

  useEffect(() => {
    try {
      const cached = localStorage.getItem(CACHE_KEY);

      if (cached) {
        try {
          const parsed = JSON.parse(cached);
          const isExpired = Date.now() - parsed.timestamp > CACHE_DURATION;

          if (!isExpired) {
            setEnrolmentCount(parsed.data.enrolment_count);
            setCourseCount(parsed.data.course_count);
            return; // skip API call
          }
        } catch (err) {
          console.warn("Invalid cache, clearing...");
          localStorage.removeItem(CACHE_KEY);
        }
      }

      // Fetch fresh data
      getRequest("/api/landing_courses.json")
        .then((response: any) => {
          const data = response.data;
          setEnrolmentCount(data.enrolment_count);
          setCourseCount(data.course_count);

          try {
            localStorage.setItem(
              CACHE_KEY,
              JSON.stringify({
                data,
                timestamp: Date.now(),
              }),
            );
          } catch (err) {
            console.warn("Failed to write cache:", err);
          }
        })
        .catch((err) => {
          console.error("API request failed:", err);
        });
    } catch (err) {
      console.error("API request failed:", err);
    }
  }, []);

  return (
    <>
      <a href="#about" className="skip-link sr-only">
        Skip to main content
      </a>
      <main className="ui pages" id="about">
        <Icons />
        <Hero />
        <GoldenCircle />
        <SkillsSection />
        <FounderNote />
        <Numbers enrolmentCount={enrolmentCount} courseCount={courseCount} />
        <Manifesto />
        <Stories />
        <Humans />
        <Cast />
        <Crowd />
        <FinalCta />
      </main>
    </>
  );
};
export default observer(About);
